import { TableBody, TableCell, TableRow } from '@mui/material';
import { ReactElement } from 'react';
import { useDataTableDataContext } from 'ra-core';
import { DataTableBody as BaseDataTableBody, type DataTableBodyProps } from 'ra-ui-materialui';
import type { ClicksSummariesResource } from '../../../../Entities/ClicksSummary';

function getTotals(data: ClicksSummariesResource[]) {
  return data.reduce(
    (acc, record) => {
      const attributes = record.attributes ?? {};

      return {
        total_clicks: acc.total_clicks + (attributes.total_clicks ?? 0),
        getprice_clicks: acc.getprice_clicks + (attributes.getprice_clicks ?? 0),
        future_clicks: acc.future_clicks + (attributes.future_clicks ?? 0),
        other_clicks: acc.other_clicks + (attributes.other_clicks ?? 0),
      };
    },
    {
      total_clicks: 0,
      getprice_clicks: 0,
      future_clicks: 0,
      other_clicks: 0,
    },
  );
}

export default function ClicksSummaryTotalsBody(props: DataTableBodyProps): ReactElement {
  const data = useDataTableDataContext<ClicksSummariesResource>() ?? [];
  const totals = getTotals(data);

  return (
    <>
      <TableBody>
        <TableRow>
          <TableCell>Total</TableCell>
          <TableCell>{totals.total_clicks}</TableCell>
          <TableCell>{totals.getprice_clicks}</TableCell>
          <TableCell>{totals.future_clicks}</TableCell>
          <TableCell>{totals.other_clicks}</TableCell>
        </TableRow>
      </TableBody>
      <BaseDataTableBody {...props} />
    </>
  );
}
